import { Dispatch, SetStateAction, createContext, useContext } from 'react';
import { AppContext } from 'store/context';
import { DialogContext } from 'store/context/dialog';
import { MedicinesContext } from 'store/context/medicines';

export const useAppContext = () => {
  const app = useContext(AppContext);
  const dialog = useDialogContext();

  const context = {
    app,
    dialog,
  };

  if (!context) {
    throw new Error('useAppContext must be used within an AppContextProvider');
  }

  return context;
};

export const useDialogContext = () => {
  // src\components\molecules\modal\global-dialog.tsx
  const context = useContext(DialogContext);

  if (!context) {
    throw new Error('useDialogContext must be used within an DialogProvider');
  }

  return context;
};

export const useMedicinesContext = () => {
  const context = useContext(MedicinesContext);

  if (!context) {
    throw new Error('useMedicinesContext must be used within an MedicinesProvider');
  }

  return context;
};

interface TabContentContextState {
  tabContent: TabContentState;
  setTabContent: Dispatch<SetStateAction<TabContentState>>;
}

export const TabContentContext = createContext<TabContentContextState | null>(null);

export const useTabContentContext = () => {
  const context = useContext(TabContentContext);

  if (!context) {
    throw new Error('useTabContentContext must be used within an TabContentContextProvider');
  }

  return context;
};

interface PanelContentContextState {
  panelContent: PanelContentState;
  setPanelContent: Dispatch<SetStateAction<PanelContentState>>;
}

export const PanelContentContext = createContext<PanelContentContextState | null>(null);

export const usePanelContentContext = () => {
  const context = useContext(PanelContentContext);

  if (!context) {
    throw new Error('usePanelContentContext must be used within a PanelContentContextProvider');
  }

  return context;
};

